var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wrap',{ref:"wrap",attrs:{"title":_vm.title}},[_c('c-table',{staticClass:"table-w",attrs:{"amount":true,"head":_vm.head,"body":_vm.body},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var data = ref.data;
return [_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.goMore(data)}}},[_vm._v("查看")])]}}])},[_vm._v(" "),_c('template',{slot:"amount_type"},[_c('span',[_vm._v("星期一")])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d0e1ac2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/QC35.vue
// module id = null
// module chunks = 